import React, { useCallback, useEffect, useState } from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CSpinner,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react-pro'
import moment from 'moment'
import RoundService from 'src/service/RoundService'
import './PreviewRoundTable.css'

const PreviewRoundTable = ({ visible, onClose }) => {
  const [rounds, setRounds] = useState([])
  const [loading, setLoading] = useState(false)

  const fetchRounds = useCallback(async () => {
    setLoading(true)
    try {
      const res = await RoundService.getRoundPreview()
      setRounds(res?.data || [])
    } catch (e) {
      console.error('Error fetching rounds', e)
      setRounds([])
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (visible) {
      fetchRounds()
    }
  }, [visible, fetchRounds])

  return (
    <CModal visible={visible} onClose={onClose} size="lg" alignment="center" scrollable>
      <CModalHeader>
        <div>
          <CModalTitle>Rounds</CModalTitle>
          <p className="pr-modal-note">
            {loading
              ? 'Loading the schedule…'
              : `${rounds.length} ${rounds.length === 1 ? 'round' : 'rounds'} in this game`}
          </p>
        </div>
      </CModalHeader>

      <CModalBody>
        {loading ? (
          <div className="pr-empty">
            <CSpinner color="primary" />
          </div>
        ) : rounds.length === 0 ? (
          <div className="pr-empty">No rounds found</div>
        ) : (
          <div className="ge-datatable ge-datatable--no-select pr-rounds">
            <CTable responsive hover className="align-middle mb-0">
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell style={{ width: '12%' }}>Round</CTableHeaderCell>
                  <CTableHeaderCell>Start Date</CTableHeaderCell>
                  <CTableHeaderCell>Start Time</CTableHeaderCell>
                  <CTableHeaderCell>End Date</CTableHeaderCell>
                  <CTableHeaderCell>End Time</CTableHeaderCell>
                </CTableRow>
              </CTableHead>

              <CTableBody>
                {rounds.map((item, index) => (
                  <CTableRow key={item.id || index}>
                    <CTableDataCell className="pr-round-num">{item.round}</CTableDataCell>
                    <CTableDataCell className="pr-cell-date">
                      {item.start_date ? moment(item.start_date).format('D.MM.YYYY') : '-'}
                    </CTableDataCell>
                    <CTableDataCell className="pr-cell-time">
                      {item.start_date ? moment(item.start_date).format('h:mm A') : '-'}
                    </CTableDataCell>
                    <CTableDataCell className="pr-cell-date">
                      {item.end_date ? moment(item.end_date).format('D.MM.YYYY') : '-'}
                    </CTableDataCell>
                    <CTableDataCell className="pr-cell-time">
                      {item.end_date ? moment(item.end_date).format('h:mm A') : '-'}
                    </CTableDataCell>
                  </CTableRow>
                ))}
              </CTableBody>
            </CTable>
          </div>
        )}
      </CModalBody>

      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Close
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default PreviewRoundTable
